<template>
  <div class="error-card-wrapper">
    <div class="header">
      <v-icon medium class="icon">
        {{ icon }}
      </v-icon>
      {{ header }}
    </div>
    <div class="content">
      {{ content }}
    </div>
  </div>
</template>

<script setup lang="ts">
import './styles/error-message.scss';

interface ErrorMessageProps {
  header?: string;
  content?: string;
  icon?: string;
}

const props = defineProps<ErrorMessageProps>();
const header = props.header ?? '';
const content = props.content ?? '';
const icon = props.icon ?? 'mdi-alert-circle';
</script>
